import { useSelector } from 'react-redux';

import useActionsLibrary from './useActionsLibrary';

const useActions = () => {
	const actionRoles = useSelector((state) => state.actionRoles.actions);

	const actionsLibrary = useActionsLibrary();

	/**
	 * @description returns array of action objects from useActionsLibrary
	 * @param pageName which page actions requested
	 * @param actionGroup which group of actions requested (exmp: createShipment,tools,print ... ) rowActions: datatable rows
	 * @param actionObjectType which type of action requested
	 */
	const getPageActions = (pageName, actionGroup, actionObjectType) => {
		const foundRoles = [];

		actionRoles.forEach(
			(role) =>
				(role.startsWith(`/actions/${pageName}/`) || role.startsWith(`/rowActions/${pageName}/`)) &&
				foundRoles.push(role.split('/').pop())
		);

		return actionsLibrary.getActions(foundRoles, actionGroup, actionObjectType);
	};

	return { getPageActions };
};

export default useActions;
